<ng-container *ngLet="allApps$ | async">
  <div class="padding" *ngLet="routChanged$ | async">
    <app-impaired-backward-btn [link]="backLink" [titleName]="'VERSION_VISUALLY_IMPAIRED.TO_LIST_APPS' | translate"></app-impaired-backward-btn>
  </div>

  <div *ngIf="currentApp">
    <div class="container padding">
      <div class="h2-impaired mt24">{{ currentApp.name }}</div>
      <div class="body1-impaired mt12">{{ currentApp.description }}</div>
    </div>

    <div class="grid-container mt24">
      <div class="row h3-impaired border">
        <div class="padding-left">{{ 'DATA.TABLE_HEADER.CATEGORY' | translate }}:</div>
      </div>
      <div class="row body1-impaired border">
        {{ currentApp.category }}
      </div>
      <div class="row h3-impaired border">
        <div class="padding-left">{{ 'VERSION_VISUALLY_IMPAIRED.APP_PUBLICATION_DATE' | translate }}:</div>
      </div>
      <div class="row body1-impaired border">{{ currentApp.publicationDate }}</div>
      <div class="row h3-impaired border">
        <div class="padding-left">{{ 'VERSION_VISUALLY_IMPAIRED.PLATFORMS' | translate }}:</div>
      </div>
      <div class="row border">
        <div *ngFor="let appLink of currentApp.appStores; let last = last">
          <a [href]="appLink.link" class="link4-impaired" target="_blank">{{ appLink.name }}</a>
          <span class="mr8 body1-impaired" *ngIf="!last">,</span>
        </div>
      </div>

      <div class="row h3-impaired border">
        <div class="padding-left">{{ 'INFORMATION_PLACEMENT_FORM.DEVELOPER' | translate }}:</div>
      </div>
      <div *ngIf="!currentApp.developerLink" class="row body1-impaired border">{{ currentApp.developer }}</div>

      <a *ngIf="currentApp.developerLink" [href]="currentApp.developerLink" class="row link4-impaired border" target="_blank">{{ currentApp.developer }}</a>
    </div>
  </div>
</ng-container>
